import React, { Component } from 'react';
import Carousel from './Carousel';
import Attachment from './Attachment';

class BotMessage extends Component {
  render() {
    const { activity, blockPosition } = this.props;

    // Special case for when we have multiple attachments
    if (
      activity.attachmentLayout === 'carousel' &&
      activity.attachments &&
      activity.attachments.length
    ) {
      return <Carousel blockPosition={blockPosition} activity={activity} />;
    }

    return <Attachment blockPosition={blockPosition} activity={activity} />;
  }
}

export default BotMessage;



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/index.js